<!-- 设备列表页面 -->
<template>
  <div class="vcnDeviceList vcnDevicelist_warpd">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <!-- 左侧树 -->
      <div class="section-mian_left tree-line-style">
        <el-scrollbar class="scroll-bar-view">
          <el-tree
            :data="treeData"
            :props="treeProps"
            class="shebeiDiv"
            @node-click="currentChange"
            :expand-on-click-node="true"
            :default-expand-all="false"
            :default-expanded-keys="['1']"
            :highlight-current="true"
            node-key="thirdDeviceId"
            ref="refTree"
          >
            <template slot-scope="{ node }">
              <element-tree-line
                :node="node"
                :showLabelLine="true"
                :indent="16"
                class="tree-line"
              >
                <span class="custom-tree-node" style="display: block">
                  <span style="margin-left: 3px">{{ node.label }}</span>
                </span>
              </element-tree-line>
            </template>
          </el-tree>
        </el-scrollbar>
      </div>
      <!-- 右侧表单 -->
      <div class="section-mian_right">
        <!-- 主机设备列表 -->
        <div class="nvr-table">
          <!-- 头部按钮 -->
          <div class="section-mian__toolbar flex-row">
            <el-button
              type="primary"
              class="iss-operation-button"
              icon="iconfont icon-iconfontfanhui"
              @click="retBtn"
              >返回</el-button
            >
            <el-button
              type="primary"
              class="iss-operation-button"
              icon="el-icon-plus"
              @click="add"
              >新增</el-button
            >
            <el-button
              type="primary"
              class="iss-operation-button"
              icon="el-icon-delete"
              @click="handleBatchDel"
              >批量删除</el-button
            >
          </div>
          <!-- 表格部分 -->
          <div class="section-main_table">
            <ioc-table
              ref="devTab"
              :data="deviceData"
              :option="deviceOption"
              :page="devicePage"
              @row-save="handlePanelSave"
              @row-update="handlePanelSave"
              @search-change="handleSearchChange"
              @search-reset="handleResetForm"
              @current-change="handleCurrentChange"
              @selection-change="handleSelectionChange"
              @size-change="handleSizeChange"
            >
              <!-- 表单自定义 -->
              <!-- <template #controlCodeListForm="slotData">
                <el-select
                  v-model="slotData.row.controlCodeList"
                  multiple
                  @change="onControlChooseCode"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in pageState == 'edit'
                      ? controlCodeOption
                      : controlCodeData"
                    :key="item.controlCodeTypeCode || item.value"
                    :label="item.controlCodeTypeName || item.label"
                    :value="Number(item.controlCodeTypeCode || item.value)"
                  >
                    <span>{{ item.controlCodeTypeName || item.label }} </span>
                    <div class="rightBtn">
                      <span
                        @click.stop="onEditControlCodeType(item)"
                        title="点击编辑"
                        style="margin-right: 5px"
                        >编辑</span
                      >
                    </div>
                  </el-option>
                </el-select>
              </template> -->
              <!-- 定制操作栏按钮 -->
              <template slot="menu" slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="详情"
                  placement="top"
                  popper-class="tooltip-draw"
                >
                  <el-button
                    type="text"
                    class="iconfont icon-Detail"
                    @click="showDetail(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="修改"
                  placement="top"
                  popper-class="tooltip-draw"
                >
                  <el-button
                    type="text"
                    @click="update(scope.row)"
                    icon="iconfont icon-xiugai"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="删除"
                  placement="top"
                  popper-class="tooltip-draw"
                >
                  <el-button
                    type="text"
                    @click="handleDelete(scope.row)"
                    icon="iconfont icon-shanchu"
                  ></el-button>
                </el-tooltip>
              </template>
            </ioc-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import ElementTreeLine from "element-tree-line";
import { api } from "../../api/index";
import { Dic, Dates } from "$utils";
import utils from "@src/common/utils";
import { tableOption } from "../../config/gateWayTable";

export default {
  components: {
    ElementTreeLine,
  },
  data() {
    return {
      pageState: "add",
      // 选中设备ID集合
      selectionList: [],
      // 查询字段
      queryForm: {},
      // 系统id
      systemId: "",
      systemName: "",
      deviceType: "",
      // 树的props
      treeProps: {
        label: "thirdDeviceName",
        children: "subDeviceList",
      },
      // 设备树的数据
      treeData: [],
      // 设备ID
      deviceId: "",
      // 分页属性设置
      devicePage: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },

      deviceData: [],
      deviceOption: tableOption(this),
    };
  },
  created() {
    this.systemId = this.$route.query.systemId;
    this.systemName = this.$route.query.systemName;
    this.deviceType = this.$route.query.deviceType;
    this.getDevList();
  },
  mounted() {
    // 请求树根节点
    this.getTreeData();
  },
  methods: {
    handlePanelSave(formInfo, done) {
      this.submitPanel(formInfo, done);
    },
    submitPanel(formInfo,done) {
      let params = {
        abscissa: "",
        buildingCode: "",
        deviceExtendInfoMap: {},
        deviceMark: "25",
        deviceType: this.deviceType,
        deviceVersion: "",
        height: "",
        ip: formInfo.deviceHost,
        port: formInfo.devicePort,
        isIndoor: "",//0
        latitude: formInfo.latitude,
        longitude: formInfo.longitude,
        ordinate: "",
        parentDeviceId: this.systemId,
        parentDeviceIds: this.systemId,
        status: formInfo.status,
        systemId: this.systemId,
        thirdDeviceDesc: formInfo.thirdDeviceDesc,
        thirdDeviceId: formInfo.thirdDeviceId,
        thirdDeviceName: formInfo.deviceName,
        typeMark: "",
        width: "",
        userName: formInfo.userName,
        password: formInfo.password,
        channelName: formInfo.channelName,
      };
      let url = api.device.addPlatSystemDeviceList;
      if (this.pageState == "edit") {
        params.deviceID = formInfo.deviceID;
        url = api.device.updatePlatSystemDeviceList;
      }
      // console.info("111111====",params)
      this.$fetch(url, params).then((res) => {
        if (res && res.success) {
          this.getDevList();
          this.$message.success(res.msgContent);
          done();
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // table多选回调
    handleSelectionChange(val) {
      this.selectionList = val.map((el) => {
        return el.deviceID;
      });
    },
    // 返回按钮
    retBtn() {
      this.$router.push("/deviceaccess/index");
    },
    // 树的子节点点击事件
    currentChange(data, node) {
      this.getDevList();
    },
    getTreeData() {
      const params = {
        systemId: this.systemId,
      };
      this.$fetch(api.device.queryPlatSystemDeviceTree, params).then((res) => {
        if (res.success) {
          this.treeData = [res.returnObj];
          this.$nextTick(() => {
            this.$refs.refTree.setCurrentKey(this.treeData[0]);
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 请求数据列表数据
    getTableList() {
      const param = {
        pageSize: this.devicePage.pageSize,
        pageNum: this.devicePage.currentPage,
        systemId: this.systemId,
        ...this.queryForm,
      };
      this.$fetch(api.device.queryPlatSystemDeviceList, param).then((res) => {
        if (res.success) {
          this.deviceData = res.returnObj.list;
          this.devicePage.total = res.returnObj.total;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 根据树查询设备列表
    getDevList() {
      this.devicePage.currentPage = 1;
      this.getTableList();
    },
    // 批量删除设备
    handleBatchDel() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t("deviceAccess.message.deltips"));
        return;
      }
      this.$confirm("此操作将删除该设备,是否继续", "删除确认", {
        confirmButtonText: this.$t("deviceAccess.button.confirm"),
        cancelButtonText: this.$t("deviceAccess.button.cancel"),
        type: "warning",
      }).then(() => {
        this.deletePlatDevice();
      });
    },
    // 单独删除设备
    handleDelete(row) {
      this.selectionList = [row.deviceID];
      this.$confirm("此操作将删除该设备,是否继续", "删除确认", {
        confirmButtonText: this.$t("deviceAccess.button.confirm"),
        cancelButtonText: this.$t("deviceAccess.button.cancel"),
        type: "warning",
      }).then(() => {
        this.deletePlatDevice();
      });
    },
    // 确认删除
    deletePlatDevice() {
      let params = { deviceIDList: this.selectionList };
      this.$fetch(api.device.deletePlatSystemDevice, params).then((res) => {
        if (res.success) {
          this.getDevList();
          this.$message.success(this.$t("deviceAccess.message.delsuccess"));
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 查看详情
    showDetail(row) {
      this.$refs.devTab.rowView(row);
    },
    // 重置搜索
    handleResetForm() {
      this.devicePage.pageSize = utils.Cache.get("CURRENT_PAGESIZE") || 10;
      this.devicePage.pageNo = 1;
      this.queryForm = {};
      // 请求设备列表
      this.getTableList();
      this.devicePage.currentPage = 1;
    },

    // 点击上一页下一页按钮
    handleCurrentChange(val) {
      this.devicePage.currentPage = val;
      this.getTableList();
    },
    // 修改每页数据数量
    handleSizeChange(val) {
      this.devicePage.currentPage = 1;
      this.devicePage.pageSize = val;
      this.getDevList();
    },

    // 新增
    add() {
      this.pageState = "add";
      this.$refs.devTab.rowAdd();
    },
    // 编辑
    update(row) {
      this.pageState = "edit";
      this.$refs.devTab.rowEdit({ ...row });
    },
    handleSearchChange(param) {
      this.queryForm = param;
      this.devicePage.currentPage = 1;
      this.getTableList();
    },
  },
};
</script>
  <style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.rightBtn {
  display: none;
  @include set_theme_color(color, main-theme-color);
}
.el-select-dropdown__item {
  &:hover {
    .rightBtn {
      float: right;
      font-size: 13px;
      display: block !important;
    }
  }
}
.vcnDeviceList {
  width: 100%;
  height: 100%;
  .section-main__warp {
    margin: 0 !important;
  }
  .upload-demo {
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
  <style lang="scss">
@import "~@src/common/assets/style/mixin";
.vcnDevicelist_warpd {
  .el-table__fixed-right-patch {
    display: none;
  }
  .devDtaildata {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .nvr-table {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .tree-content {
    width: fit-content;
    min-width: 100%;
    .el-tree-node__label {
      display: inline-block;
      max-width: 80%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .el-tree-node__content {
      height: 40px;
      line-height: 40px;
      &:hover {
        background: rgb(45, 73, 118);
      }
      .custom-tree-node {
        width: 100%;
        height: 40px;
        line-height: 40px;
        display: flex;
        .tree-label {
          width: 150px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .area-operator {
          display: inline-block;
          margin-left: 10px;
        }
      }
      &:before {
        margin-top: -26px !important;
      }
    }
  }
  .scroll-bar-view {
    margin: 15px 0;
    // @include set_theme_color(background-color, top-menu-bg-color);
    height: calc(100% - 50px);
    .el-scrollbar__wrap {
      // height: calc(100% - 100px);
      .el-scrollbar__view {
        display: inline-block;
        min-width: 100%;
      }
    }
  }
}
</style>
  